const PENDING = "Pending";
const DISPATCHED = "Dispatched";
const PICKED_UP = "PickedUp";
const SHIPPED = "Shipped";
const DELIVERED = "Delivered";
const FULFILLED = "FulFilled";

export default Object.freeze({
    PENDING,
    DISPATCHED,
    PICKED_UP,
    DELIVERED,
    FULFILLED,
    SHIPPED
});


// WEBPACK FOOTER //
// ./src/constants/dispatchStatus.js